import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { Route, Redirect } from "react-router-dom";
import React from "react";
import { selectAuthState, selectAuthRequesting } from "./selectors";
import { connect } from "react-redux";
import LinearProgress from "@material-ui/core/LinearProgress";

var PrivateRoute = function PrivateRoute(_ref) {
  var Component = _ref.component,
      auth = _ref.auth,
      requesting = _ref.requesting,
      rest = _objectWithoutProperties(_ref, ["component", "auth", "requesting"]);

  var render = function render(props) {
    if (auth === true) {
      return /*#__PURE__*/React.createElement(Component, Object.assign({}, props, rest));
    } else if (requesting === true) {
      return /*#__PURE__*/React.createElement(LinearProgress, null);
    } else {
      return /*#__PURE__*/React.createElement(Redirect, {
        to: {
          pathname: "/login"
        }
      });
    }
  };

  return /*#__PURE__*/React.createElement(Route, Object.assign({}, rest, {
    render: render
  }));
};

var mapStateToProps = function mapStateToProps(store) {
  return {
    auth: selectAuthState(store),
    requesting: selectAuthRequesting(store)
  };
};

export default connect(mapStateToProps, {})(PrivateRoute);